<sp-color-picker
    [color]="color"
    [ariaLabel]="ariaLabel"
    [positionLeft]="positionLeft"
    [hideGradient]="hideGradient"
    [colorsPreset]="selectedThemeColors()"
    (colorChangeEvent)="colorChangeEvent.emit($event)"
></sp-color-picker>
